<template>
  <div class="container">
    <iframe id="VimeoURL" :src="videoUrl" title="The Thinking Traveller" class="video" width="1920" height="1080" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen />
  </div>
</template>

<script>
export default {
  props: {
    id: { type: Number, required: true },
    hash: { type: String, required: true },
  },
  computed: {
    /**
     * Returns the embedded video url for the iframe
     * 
     * @return {string}
     */
    videoUrl() {
      return `https://player.vimeo.com/video/${this.id}?h=${this.hash}&background=1&autoplay=1&loop=1&byline=1&title=1`;
    },
  },
};

</script>

<style lang="scss" scoped>

.container {
  margin: 0;
  padding: 0;
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vh;
  transform: translate(-50%, -50%);
}

@media (min-aspect-ratio: 16/9) {
  .video {
    height: 56.25vw;
  }
}
@media (max-aspect-ratio: 16/9) {
  .video {
    width: 177.78vh;
  }
}

</style>
